export default {
    login: {
        title: "会员登录",
        username: "账号",
        password: "密码",
        remember: "记住账号",
        submit: "登录",
        register: "注册",
        registerTitle: "注册账号",
        confirmPassword: "确认密码",
        currency: "货币",
        submitRegister: "注册",
        needInputRegister: "请填写所有字段",
        backToLogin: "返回登录",
        passwordNotMatch: "两次输入的密码不一致",
        registerFailed: "注册失败",
        checkFailed: "用户名检查失败",
        needInput: "请输入账号和密码"
    },
    common: {
        welcome: "欢迎",
        logout: "退出",
        lang_en: "English",
        lang_zh: "中文",
        lang_km: "ខ្មែរ"
    },
    menu: {
        news: "资讯",
        lotto: "基诺",
        lottery: "彩种",
        balance: "余额",
        report: "报表",
        changePassword: "修改密码"
    },
    sub: {
        lotto: "基诺",
        winResult: "获胜结果",
        winResultV1: "获胜结果 V1",
        result: "历史开奖"
    },
    left: {
        balances: "余额",
        outstanding: "未结算",
        lastResult: "最近结果",
        currentTicket: "本期注单",
        previousTicket: "历史注单"
    },

    lotto: {
        over: "大",            // O
        under: "小",          // U
        underover: "大/小",
        total: "和",
        qian: "1000",
        liangqian: "2000",
        wuqian: "5000",
        wan: "10000",
        liangwan: "20000",
        wuwan: "50000",
        ershiwan: "200000",
        wushiwan: "500000",
        LimitBetting: "限注",
        MaxPayout: "最高赔付",
        Stake: "投注",
        BET: "下注",
        CANCEL: "取消",
        RESET: "重置",
        rangeTitle: "区间",
        bettingClosed10Seconds: "投注于最后10秒结束。"
    },
    report: {
        No: "编号",
        Date: "日期",
        Remark: "备注",
        Turnover: "周转",
        ValidBet: "有效流水",
        NetWL: "输赢",
        Comm: "账户",
        Deposit: "存款",
        Withdraw: "取款",
        Balance: "余额",
        Return: "返回",
        Info: "信息",
        Bet: "注单",
        Result: "结果",
        Stack: "金额",
        Status: "输赢",
        Winlose: "金额"
    },
    result: {
        No: "标号",
        Date: "日期",
        GetResult: "查询",
        Today: "今天",
        Yesterday: "昨天",
        Title: "期号",
        Result: "和值",
        Detail: "开奖详情",
        Bonus: "奖金",
        UnderOver: "大小",
        Range: "区间",
        clear: "清除",
        weekdays: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
    },
    Balance: {
        AccountInfo: "账户信息",
        Account: "账户",
        UserName: "用户名",
        Lastlogintime: "最后登录时间",
        LastloginIP: "最后登录IP",
        CreditInfo: "信用信息",
        Currency: "货币",
        CashBalance: "可用余额",
        Outstanding: "未结算余额",
        GivenCredit: "已获信用额",
        BetCredit: "投注信用额"
    },
    Changepassword: {
        Changeyourpassword: "更改你的密码",
        OldPassword: "旧密码",
        NewPassword: "新密码",
        ConfirmPassword: "确认密码",
        Confirm: "提交",
        Clear: "清除",
        Note: "注意",
        Note1: "新密码不能与登录ID相同",
        Note2: "新密码至少应包含1个字母和1个数字，且长度不得少于6位",
        Note3: "新密码不能过于简单，例如aaaa1111"
    },
    footer: {
        footer: "© Copyright 2026 LOTTO8888, All rights reserved"

    },
    print: {
        issue: "期号",
        ticketId: "票号",
        time: "时间",
        betType: "投注类型",
        coef: "系数",
        winlose: "输赢",
    }

};
